import React from 'react';

const FeedbackCart = (props) => {
    return (
        <div onClick={props.onClick} style={{ cursor: 'pointer', width: 90, height: 90, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', border: '1px solid #DDDDDD', borderRadius: 4 }}>
            <div style={{ height: 28, width: 28 }}>
                {props?.icon}
            </div>
            <div style={{ textAlign: 'center', marginTop: 4, color: '#B0B0B0', fontSize: 12 }}>
                {props.text}
            </div>
        </div>
    );
}

export default FeedbackCart;